import React from 'react';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ICCIDGenerator from './ICCIDGenerator';
import '../styles/Sidebar.css';

const Sidebar = ({ onArticleSelect, onNewbieClick, isAuthenticated, onLogout, onBuyClick }) => {
  const courseContent = [
    {
      title: "Targeting issues",
      subsections: [
        { title: "What phone to choose?", path: "/articles/targeting-issues/phone-selection.md" },
        { title: "How to cheat all apps targeting?", path: "/articles/targeting-issues/cheat-targeting.md" },
        { title: "Why mod APKs are not working?", path: "/articles/targeting-issues/mod-apks.md" },
        { title: "Why emulators are not working?", path: "/articles/targeting-issues/emulators.md" },
        { title: "Why jailbreak / root is not working?", path: "/articles/targeting-issues/jailbreak-root.md" },
        { title: "Why anti-detect browser is not working?", path: "/articles/targeting-issues/antidetect-browser.md" }
      ]
    },
    {
      title: "SIM card issue",
      subsections: [
        { 
          title: "SIM card manipulation 1", 
          path: "/articles/sim-card/manipulation1.md",
          badge: "2 Videos"
        },
        { title: "SIM card manipulation 2", path: "/articles/sim-card/manipulation2.md" },
        { title: "No SIM Card Approach?", path: "/articles/sim-card/nosimcard.md" },
        { 
          title: "Geotargeting Code Generator", 
          path: "/articles/sim-card/iccid-generator.md",
          badge: "App",
          badgeColor: "green"
        }
      ]
    },
    {
      title: "IP problem",
      subsections: [
        { title: "Do you need to use geotargeted IP?", path: "/articles/ip/geotargeted-ip.md" },
        { title: "Can 4G IP be banned?", path: "/articles/ip/4g-ip-ban.md" },
        { title: "Can apps detect you are using proxy or VPN?", path: "/articles/ip/proxy-vpn-detection.md" },
        { title: "TikTok Internet Solution", path: "/articles/ip/tiktok_solution.md" },
        { 
          title: "Internet Solution 1", 
          path: "/articles/ip/wifi-proxy.md",
          badge: "4 Videos"
        },
        { 
          title: "Internet Solution 2", 
          path: "/articles/ip/ethernet-proxy.md",
          badge: "2 Videos"
        },
        { 
          title: "Internet Solution 3", 
          path: "/articles/ip/usb.md"
        },
        { 
          title: "Internet Solution 4", 
          path: "/articles/ip/share-vpn.md",
          badge: "2 Videos"
        },
        { 
          title: "Internet Solution 5", 
          path: "/articles/ip/ethernet.md",
          badge: "3 Videos"
        }
      ]
    },
    {
      title: "Email Problem",
      subsections: [
        { title: "Trust issue", path: "/articles/email/trust-issue.md" },
        { title: "Trusted disposable emails", path: "/articles/email/disposable.md" },
        { 
          title: "Sign up with Google & Apple", 
          path: "/articles/email/google-signup.md"
          
        }
      ]
    },
   
    {
      title: "Android Configuration",
      subsections: [
        { title: "What Android is the best for social media", path: "/articles/android/best-android.md" },
        { 
          title: "Android Configuration", 
          path: "/articles/android/date-time.md",
          badge: "7 Videos"
        },
        { title: "Permissions management", badge: "1 Video", path: "/articles/android/permissions.md" },
        { title: "Factory reset?", path: "/articles/android/factory-reset.md" }
      ]
    },
    {
      title: "iPhone Configuration",
      subsections: [
        { title: "iOS is better?", path: "/articles/ios/iosbetter.md" },
        { 
          title: "iPhone Configuration", 
          path: "/articles/ios/iosconfiguration.md",
          badge: "8 Videos"
        },
        { title: "Factory reset?", path: "/articles/ios/factory.md" }
      ]
    },
    {
      title: "Multi Apps",
      subsections: [
        { 
          title: "TikTok", 
          path: "/articles/apps/tiktok.md",
          badge: "3 Videos"
        },
        { 
          title: "Instagram / Facebook", 
          path: "/articles/apps/instagram.md",
          badge: "3 Videos"
        },
      
        { 
          title: "Twitter", 
          path: "/articles/apps/twitter.md",
          badge: "1 Video"
        },
      
        { 
          title: "Whatsapp", 
          path: "/articles/apps/whatsapp.md",
          badge: "2 Videos"
        },
        { 
          title: "Youtube", 
          path: "/articles/apps/youtube.md",
          badge: "1 Video"
        },
        { 
          title: "Pinterest", 
          path: "/articles/apps/pinterest.md",
          badge: "2 Videos"
        },
        { 
          title: "Bluesky", 
          path: "/articles/apps/bluesky.md",
          badge: "2 Videos"
        },
        { 
          title: "Reddit", 
          path: "/articles/apps/reddit.md",
          badge: "1 Video"
        },
       
        { 
          title: "Spotify", 
          path: "/articles/apps/spotify.md",
          badge: "1 Video"
        },
        { 
          title: "Snapchat", 
          path: "/articles/apps/snapchat.md",
          badge: "2 Videos"
        },
        { 
          title: "Trust Pilot", 
          path: "/articles/apps/trust.md",
          badge: "2 Videos"
        },
        { 
          title: "Telegram", 
          path: "/articles/apps/telegram.md",
          badge: "Tutorial",
          badgeColor: "green"
        },
        { 
          title: "Gmail", 
          path: "/articles/apps/gmail.md",
          badge: "Very Short Guide",
          badgeColor: "green"
        }
      ]
    },
    {
      title: "TikTok Tips",
      subsections: [
        { title: "Warm up accounts", path: "/articles/warmup/warmup.md" },
        { title: "Repurpose videos", path: "/articles/warmup/repurpose.md", badge:"2 Videos" },
        { title: "Links on TikTok!", path: "/articles/warmup/linksontiktok.md", badge: "2 Videos" }
        
      ]
    },
    {
      title: "Landing Page",
      subsections: [
        { 
          title: "Landinge pages for TikTok", 
          path: "/articles/landing/landing1.md",
          badge: "Code",
          badgeColor: "orange"
        }
      ]
    }
  ];

  const handleICCIDGeneratorClick = () => {
    onArticleSelect('iccid-generator');
  };

  const handleLoginClick = () => {
    if (isAuthenticated) {
      onLogout();
    } else {
      onArticleSelect('/sign-in');
    }
  };

  return (
    <div className="sidebar">
      <div className="action-buttons">
        <button className="buy-button" onClick={onBuyClick}>Buy Course</button>
        <button className="login-button" onClick={handleLoginClick}>
          {isAuthenticated ? 'Log out' : 'Log in'}
        </button>
      </div>
      {courseContent.map((section, index) => (
        <div key={index} className="section">
          <h3>{section.title}</h3>
          <ul>
            {section.subsections.map((subsection, subIndex) => (
              <li 
                key={subIndex}
                onClick={() => {
                  if (subsection.special) {
                    onNewbieClick();
                  } else if (subsection.path === '/articles/sim-card/iccid-generator.md') {
                    handleICCIDGeneratorClick();
                  } else {
                    onArticleSelect(subsection.path);
                  }
                }}
              >
                <div className="subsection-item">
                  <MenuBookIcon className="book-icon" />
                  <div className="subsection-content">
                    <span>{subsection.title}</span>
                    {subsection.badge && (
                      <span className={`badge ${
                        subsection.badgeColor === 'green' 
                          ? 'badge-green' 
                          : subsection.badgeColor === 'orange'
                          ? 'badge-orange'
                          : ''
                      }`}>
                        {subsection.badge}
                      </span>
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Sidebar; 